import React from 'react';
import classNames from 'classnames';
import cls from './TasksContainer.module.css';
import { TasksBlockType } from '../../../../../model/taskBoard';
import { Icon } from '../../../../../../../shared/ui';
import { useTranslation } from 'react-i18next';

interface TasksContainerProps {
    classes?: string;
    type: TasksBlockType;
    children: React.ReactNode;
}

export const TasksContainer = ({ classes, children, type }: TasksContainerProps) => {
    const { t } = useTranslation();
    const TasksContainerTitle: Record<TasksBlockType, string> = {
        [TasksBlockType.OVERDUE]: t('TasksContainer.TasksContainerTitle.TasksBlockType.OVERDUE'),
        [TasksBlockType.NO_TERM]: t('TasksContainer.TasksContainerTitle.TasksBlockType.NO_TERM'),
        [TasksBlockType.IN_PROCESS]: t(
            'TasksContainer.TasksContainerTitle.TasksBlockType.IN_PROCESS'
        ),
        [TasksBlockType.TODAY]: t('TasksContainer.TasksContainerTitle.TasksBlockType.TODAY'),
        [TasksBlockType.IN_WEEKS]: t('TasksContainer.TasksContainerTitle.TasksBlockType.IN_WEEKS'),
    };

    const iconMapping = {
        outdated: <Icon iconName={'overdue'} />,
        in_progress: <Icon iconName={'inProcess'} />,
        today: <Icon iconName={'today'} />,
        seven_days: <Icon iconName={'inWeeks'} />,
        no_term: <Icon iconName={'taskQuestion'} />,
    };

    return (
        <div className={classNames(cls.TasksContainer, [classes], cls[type])}>
            <span className={classNames(cls.ContainerTitle, cls[type])}>
                {iconMapping[type]}
                {TasksContainerTitle[type]}
            </span>
            <div className={cls.TaskContainerWrapper}>{children}</div>
        </div>
    );
};
